import loader from './lib/Loader';

import(/* webpackPrefetch: true */ './icons');
loader('slider', '.slider');
loader('text-size', '#text-adjustor');
loader('oogziektes-dropdown', '.meer-oogziektes');
loader('black-white', '#black-white');
loader('navbar', '.header');
loader('menu', '.header');
loader('search-bar', '.header');
loader('accessibility-menu', '.view-accessibility');
loader('readspeaker', '.page-player');
loader('accordion', '.cafe-accordion');
loader('accordion', '.contact-accordion');
loader('popup', '.overlay');
loader('newsletter', '.newsletter-form');
loader('news-event-items', '.news-item, .event-item');
loader('login-form', '.login-form');
loader('pre-donate', '#donate');
loader('donate', '.donate-gform');
loader('media-player', '.media');
loader('play-audio', '.play-audio');
loader('scroll-top', '.footer__gotop');
loader('team', '.team');
loader('reset-filters', '#reset-filters');
